import React, { createContext, ReactNode, useCallback, useContext, useState } from "react";
import { getCurrentYear } from "../../model/accounting/date/getCurrentYear.js";
import { getCurrentMonth } from "../../model/accounting/date/getCurrentMonth.js";
import { MonthStar } from "../../model/accounting/date/MonthStar.js";

/**
 * The filter store state type.
 */
type FilterState = {
  year: string;
  month: MonthStar;
  titleSearch: string;
  setPeriod: (year: string, month: MonthStar) => void;
  setTitleSearch: (search: string) => void;
};

/**
 * The period store context.
 */
const FilterContext = createContext<FilterState | undefined>(undefined);

/**
 * The period store provider.
 */
export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [year, setYear] = useState(() => getCurrentYear());
  const [month, setMonth] = useState<MonthStar>(() => getCurrentMonth());

  const [titleSearch, setTitleSearch] = useState("");

  const setPeriod = useCallback((year: string, month: MonthStar) => {
    setYear(year);
    setMonth(month);
  }, []);

  const value = { year, month, titleSearch, setPeriod, setTitleSearch };

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

/**
 * Hook to access the filter state.
 */
export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("The filter context is not provided.");
  }
  return context;
};
